import { Component, ElementRef, OnDestroy, OnInit } from "@angular/core";
import { SharedAnimations } from "src/app/shared/animations/shared-animations";
import { Observable, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { SessionService } from "src/app/store/session/session.service";
import { environment } from 'src/environments/environment';
import {
  Router,
  RouteConfigLoadStart,
  ResolveStart,
  RouteConfigLoadEnd,
  ResolveEnd,
  ActivatedRoute
} from "@angular/router";
import { SessionQuery } from "src/app/store/session/session.query";
import { OpenService } from "@app-services/open.service";
import { LayoutVars } from "@app/store/session/session.store";
import { MarketPlacePersonalizationUtils } from "@app-components/layouts/shopkeeper-layout/marketplace-personalization";
import { AmplifyService } from "@app-services/amplify.service";
import { FederatedLoginConfig } from "@app/views/private/admin/model/advertisers";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
  animations: [SharedAnimations]
})
export class LoginComponent implements OnInit, OnDestroy {
  statusUser: string = null;
  showError = false;
  messageError = "";

  public readonly form = this._buildForm();

  public readonly loading$: Observable<boolean> = this.sessionQuery.selectLoading();
  loadingText: string;

  cellPhone: string;
  sentSMS: boolean;
  layoutVars: LayoutVars;
  layoutVarsResponse: boolean;

  public returnUrl: string = this.route.snapshot.queryParams["returnUrl"];

  public env: string = environment.urlBlog;
  public readonly blogUrl = environment.urlBlog;

  textError = "";
  showSuperBidLogin = false;

  public providedEmailAddress?: string = null;

  private readonly _unsubscribeAll = new Subject<void>();

  constructor(
    private fb: FormBuilder,
    private sessionService: SessionService,
    private router: Router,
    private route: ActivatedRoute,
    private sessionQuery: SessionQuery,
    private openService: OpenService,
    private elRef: ElementRef,
    private amplifyService: AmplifyService
  ) {
    this.openService
      .getLayoutVars()
      .subscribe(result => {
        MarketPlacePersonalizationUtils.initCssVars(this.elRef, result);
        this.layoutVars = result;
        this.layoutVarsResponse = true;

        if (this.layoutVars) {
          this.showSuperBidLogin = this.layoutVars.showSuperBidLogin;
          if (this.layoutVars.logoDestinationUrl) {
            this.env = this.layoutVars.logoDestinationUrl;
          }
        }
      });
  }

  ngOnInit() {

    this.router.events.subscribe(event => {
      if (
        event instanceof RouteConfigLoadStart ||
        event instanceof ResolveStart
      ) {
        this.loadingText = "Carregando seus dados...";
        this.sessionService.setLoading(true);
      }
      if (event instanceof RouteConfigLoadEnd || event instanceof ResolveEnd) {
        this.sessionService.setLoading(false);
      }
    });

    this.form.get('email').valueChanges
      .pipe(
        takeUntil(this._unsubscribeAll)
      )
      .subscribe((email: string) => {
        if (email && email.length > 0) {
          this.providedEmailAddress = email;
        } else {
          this.providedEmailAddress = null;
        }
      });

  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

  submitFederatedLogin(config: FederatedLoginConfig): void {
    this.amplifyService.loginFederated(config.appClientIdAD, config.cognitoDomainAD, config.identityProviderAD);
  }

  signin(values) {
    this.cellPhone = undefined;
    this.showError = false;
    this.loadingText = "Aguarde...";
    if (this.statusUser === null || this.statusUser === "USER_NOT_FOUND") {
      values.email = String(values.email).toLowerCase();
      this.sessionService.checkEmailStatus(values.email).subscribe(
        response => {
          this.statusUser = response.status;
          if (response.status === "REGISTERED_USER") {
            this.form.get("email").disable();
            this.form.addControl(
              "password",
              this.fb.control("", [Validators.required])
            );
          } else if (response.status === "USER_NOT_FOUND") {
            this.showError = true;
          } else if (response.status === "UNREGISTERED_USER") {
            this.statusUser = response.status;
            this.showError = true;
            this.cellPhone = response.cellPhone;
            this.messageError =
              "Um email foi enviado para o endereço abaixo. Por favor, verifique sua caixa postal para finalizar seu cadastro.";
          }
        },
        () => {
          this.showError = true;
          this.messageError =
            "Falha ao realizar o seu cadastro. Tente novamente mais tarde.";
        }
      );
      return;
    }
    if (this.form.get("password") && this.form.get("password").value) {
      const errorMessage = this.sessionService.login(
        String(values.email).toLowerCase(),
        values.password,
        this.returnUrl
      );

      errorMessage.then(message => {
        if (message) {
          this.showError = true;
          this.messageError = message;
        }
      });

    }
  }

  closeAlert() {
    this.showError = false;
  }

  sendSMS(): void {
    this.sentSMS = true;
    const emailAddress = this.form.get('email').value;
    this.sessionService
      .sendSMS(emailAddress)
      .subscribe(resp => resp);
  }

  public redirectSuperbidAccounts(): void {
    let callbackUrl = `${window.location.protocol}//${window.location.host}`;
    let authUrl = `${environment.url}/authorization/`;
    let redirectUrl = `${environment.url}`;

    if (authUrl.startsWith('https://www.') && authUrl.startsWith('http://www.')) {
      if (authUrl.startsWith('https://www.')) {
        authUrl = 'https://' + authUrl.substring(12);
      } else if (authUrl.startsWith('http://www.')) {
        authUrl = 'http://' + authUrl.substring(11);
      }
    }

    window.location.href = `${environment.superBidUrl}/signin?response_type=token&client_id=${environment.superBidClientId}&redirect_uri=${redirectUrl}/&authorization_uri=${authUrl}&language=pt-BR&portal_id=2`;
  }

  private _buildForm(): FormGroup {

    const form = this.fb.group({
      email: ["", [Validators.required, Validators.email]]
    });
    
    return form;
  }

}
